import { Vue, Component, Ref } from 'vue-property-decorator'

@Component({
    components: {}
})
export default class ScientificAnalysisNoresultsPanel extends Vue {

}
